// Returns query parameter
export const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href
  }
  name = name.replace(/[\[\]]/g, "\\$&")
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")
  const results = regex.exec(url)
  if (!results) {
    return null
  }
  if (!results[2]) {
    return ""
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "))
}

/**
 * Converts an object to an encoded string of params for a URL.
 * @method
 * @param {object} params Any object.
 * @returns {string|`${*}&${string}`} Encoded string of key value pairs.
 */
export const encodeParams = (params) => {
  return Object.entries(params).reduce((memo, [k, v]) => {
    const pair = `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
    return memo === "" ? pair : `${memo}&${pair}`
  }, "")
}
